import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom"; // Import BrowserRouter
import App from "./App";
import { AuthProvider } from "./components/Auth/AuthContext"; // Ensure you import AuthProvider
import theme from "./theme";
import { Provider } from "react-redux";
import store from "./redux/store";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // ✅ Added
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


// Get the container element
const container = document.getElementById("root");

// Create the root and render the app
const root = createRoot(container);
root.render(
  <ChakraProvider theme={theme}>
    <Router basename="/">
      {/* basename='/student' */}
      {/* basename='/vimalagiri' */}
      <AuthProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </AuthProvider>
    </Router>
  </ChakraProvider>
);

serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();
